import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Login from './pages/Login';
import Bookings from './pages/Bookings';
import BookingDetail from './pages/BookingDetail';
import CatalogList from './pages/CatalogList';
import CatalogVehicleDetail from './pages/CatalogVehicleDetail';
import './App.css';
import BookingAgreement from './pages/BookingAgreement';
import PayRedirect from './pages/PayRedirect';

// Check if user is authenticated
const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

// Private Route component
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

// Ant Design theme configuration
const theme = {
  token: {
    colorPrimary: '#2e5ec3', // Purple primary color like Garazi
    borderRadius: 8,
    colorBgContainer: '#ffffff',
  },
};

function App() {
  return (
    <ConfigProvider theme={theme}>
      <Router>
        <div className="App">
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated() ?
                  <Navigate to="/bookings" /> :
                  <Navigate to="/login" />
              }
            />
            <Route path="/login" element={<Login />} />
            <Route
              path="/bookings"
              element={
                <PrivateRoute>
                  <Bookings />
                </PrivateRoute>
              }
            />
            <Route
              path="/bookings/:id"
              element={
                <PrivateRoute>
                  <BookingDetail />
                </PrivateRoute>
              }
            />
            {/* Public Catalog Routes - No Authentication Required */}
            <Route path="/catalog/:catalogId" element={<CatalogList />} />
            <Route path="/catalog/:catalogId/vehicle/:vehicleId" element={<CatalogVehicleDetail />} />

            <Route path="/booking-agreement" element={<BookingAgreement />} />
            <Route path="/agreement/:id" element={<BookingAgreement />} />
            <Route path="/pay/:code" element={<PayRedirect />} />

          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;